import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { InputBox } from "../form-elements/inputbox.component";
import { DropdownMenu } from "../form-elements/dropdownmenu.component";
import { statusesAtAddress, usStates } from "./values";
import { InputBoxMoney } from "../form-elements/inputbox-money.component";
import { InputBoxNumber } from "../form-elements/inputbox-number.component";

interface ResidentailAddressFormProps {
  values?: any;
  errors?: any;
  touched?: any;
  handleChange?: any;
  handleBlur?: any;
  setFieldValue: any;
}

export const initialValuesResidentialAddress = {
  // step #2
  residentialAddressLine1: "",
  residentialAddressLine2: "",
  residentialCity: "",
  residentialState: "",
  residentialZipCode: "",
  yearsAtResidentialAddress: "",
  monthsAtResidentialAddress: "",
  statusAtResidentialAddress: "",
  monthlyPayment: "",

  previousAddressLine1: "",
  previousAddressLine2: "",
  previousCity: "",
  previousState: "",
  previousZipCode: "",
  previousYearsAtAddress: "",
  previousMonthsAtAddress: "",

  isRegistrationAddress: "",
  registrationAddress: "",
  isMailingAddress: "",
  mailingAddress: "",
};

export const ResidentialAddressForm: React.FC<ResidentailAddressFormProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  // {(touched.yearsAtResidentialAddress || touched.monthsAtResidentialAddress) &&
  //   (values.yearsAtResidentialAddress || values.monthsAtResidentialAddress) &&
  //   Number(values.yearsAtResidentialAddress) * 12 + Number(values.monthsAtResidentialAddress) < 24 ? (

  const shouldShowPreviousAddress =
    (touched.yearsAtResidentialAddress || touched.monthsAtResidentialAddress) &&
    (values.yearsAtResidentialAddress || values.monthsAtResidentialAddress) &&
    Number(values.yearsAtResidentialAddress) * 12 + Number(values.monthsAtResidentialAddress) < 24;

  useEffect(() => {
    if (!shouldShowPreviousAddress) {
      setFieldValue("previousAddressLine1", initialValuesResidentialAddress.previousAddressLine1);
      setFieldValue("previousCity", initialValuesResidentialAddress.previousCity);
      setFieldValue("previousState", initialValuesResidentialAddress.previousState);
      setFieldValue("previousZipCode", initialValuesResidentialAddress.previousZipCode);
      setFieldValue("previousYearsAtAddress", initialValuesResidentialAddress.previousYearsAtAddress);
      setFieldValue("previousMonthsAtAddress", initialValuesResidentialAddress.previousMonthsAtAddress);
    }
  }, [setFieldValue, shouldShowPreviousAddress]);

  return (
    <>
      <Row>
        <Col xs={12}>
          <h3>Residential Information</h3>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <InputBox
            label="Physical Address"
            name="residentialAddressLine1"
            tabIndex={1}
            value={values.residentialAddressLine1}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.residentialAddressLine1 && !errors.residentialAddressLine1}
            isInvalid={touched.residentialAddressLine1 && errors.residentialAddressLine1}
            errorFeedback={errors.residentialAddressLine1}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={12} md={4}>
          <InputBox
            label="City"
            name="residentialCity"
            tabIndex={2}
            value={values.residentialCity}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.residentialCity && !errors.residentialCity}
            isInvalid={touched.residentialCity && errors.residentialCity}
            errorFeedback={errors.residentialCity}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={4}>
          <DropdownMenu
            label="State"
            name="residentialState"
            tabIndex={3}
            options={usStates}
            value={values.residentialState}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.residentialState && !errors.residentialState}
            isInvalid={touched.residentialState && errors.residentialState}
            errorFeedback={errors.residentialState}
          />
        </Col>
        <Col xs={12} sm={6} md={4} lg={4}>
          <InputBoxNumber
            label="Zip"
            name="residentialZipCode"
            tabIndex={4}
            value={values.residentialZipCode}
            onChange={handleChange}
            onBlur={handleBlur}
            setFieldValue={setFieldValue}
            isValid={touched.residentialZipCode && !errors.residentialZipCode}
            isInvalid={touched.residentialZipCode && errors.residentialZipCode}
            errorFeedback={errors.residentialZipCode}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>Time at Residence</Col>
      </Row>
      <Row>
        <Col xs={6} lg={3}>
          <InputBoxNumber
            label="Years"
            name="yearsAtResidentialAddress"
            tabIndex={5}
            value={values.yearsAtResidentialAddress}
            onChange={handleChange}
            onBlur={handleBlur}
            setFieldValue={setFieldValue}
            isValid={touched.yearsAtResidentialAddress && !errors.yearsAtResidentialAddress}
            isInvalid={touched.yearsAtResidentialAddress && errors.yearsAtResidentialAddress}
            errorFeedback={errors.yearsAtResidentialAddress}
          />
        </Col>
        <Col xs={6} lg={3}>
          <InputBoxNumber
            label="Months"
            name="monthsAtResidentialAddress"
            tabIndex={6}
            value={values.monthsAtResidentialAddress}
            onChange={handleChange}
            onBlur={handleBlur}
            setFieldValue={setFieldValue}
            isValid={touched.monthsAtResidentialAddress && !errors.monthsAtResidentialAddress}
            isInvalid={touched.monthsAtResidentialAddress && errors.monthsAtResidentialAddress}
            errorFeedback={errors.monthsAtResidentialAddress}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <DropdownMenu
            label="Status"
            name="statusAtResidentialAddress"
            tabIndex={7}
            options={statusesAtAddress}
            value={values.statusAtResidentialAddress}
            onChange={handleChange}
            onBlur={handleBlur}
            isValid={touched.statusAtResidentialAddress && !errors.statusAtResidentialAddress}
            isInvalid={touched.statusAtResidentialAddress && errors.statusAtResidentialAddress}
            errorFeedback={errors.statusAtResidentialAddress}
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <InputBoxMoney
            label="Mortgage/Rent Amount"
            name="monthlyPayment"
            tabIndex={8}
            value={values.monthlyPayment}
            setFieldValue={setFieldValue}
            onBlur={handleBlur}
            isValid={touched.monthlyPayment && !errors.monthlyPayment}
            isInvalid={touched.monthlyPayment && errors.monthlyPayment}
            errorFeedback={errors.monthlyPayment}
          />
        </Col>
      </Row>

      {shouldShowPreviousAddress ? (
        <>
          <Row>
            <Col>
              <label>* Previous address required if at current address less than two years:</label>
            </Col>
          </Row>
          <Row>
            <Col>
              <InputBox
                label="Previous Address"
                name="previousAddressLine1"
                tabIndex={shouldShowPreviousAddress ? 100 : undefined}
                value={values.previousAddressLine1}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.previousAddressLine1 && !errors.previousAddressLine1}
                isInvalid={touched.previousAddressLine1 && errors.previousAddressLine1}
                errorFeedback={errors.previousAddressLine1}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <InputBox
                label="City"
                name="previousCity"
                value={values.previousCity}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.previousCity && !errors.previousCity}
                isInvalid={touched.previousCity && errors.previousCity}
                errorFeedback={errors.previousCity}
              />
            </Col>
            <Col>
              <DropdownMenu
                label="State"
                name="previousState"
                options={usStates}
                value={values.previousState}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.previousState && !errors.previousState}
                isInvalid={touched.previousState && errors.previousState}
                errorFeedback={errors.previousState}
              />
            </Col>
            <Col>
              <InputBoxNumber
                label="Zip"
                name="previousZipCode"
                value={values.previousZipCode}
                onChange={handleChange}
                setFieldValue={setFieldValue}
                onBlur={handleBlur}
                isValid={touched.previousZipCode && !errors.previousZipCode}
                isInvalid={touched.previousZipCode && errors.previousZipCode}
                errorFeedback={errors.previousZipCode}
              />
            </Col>
          </Row>

          <Row>
            <Col>Time at Previous Address</Col>
          </Row>
          <Row>
            <Col lg="3">
              <InputBoxNumber
                label="Years"
                name="previousYearsAtAddress"
                value={values.previousYearsAtAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                setFieldValue={setFieldValue}
                isValid={touched.previousYearsAtAddress && !errors.previousYearsAtAddress}
                isInvalid={touched.previousYearsAtAddress && errors.previousYearsAtAddress}
                errorFeedback={errors.previousYearsAtAddress}
              />
            </Col>
            <Col lg="3">
              <InputBoxNumber
                label="Months"
                name="previousMonthsAtAddress"
                value={values.previousMonthsAtAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                setFieldValue={setFieldValue}
                isValid={touched.previousMonthsAtAddress && !errors.previousMonthsAtAddress}
                isInvalid={touched.previousMonthsAtAddress && errors.previousMonthsAtAddress}
                errorFeedback={errors.previousMonthsAtAddress}
              />
            </Col>
          </Row>
        </>
      ) : null}
    </>
  );
};
